import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import { resolveMedia } from "@/lib/media";

export default function Showcase() {
  const { content } = useSite();
  const s = content?.showcase || {};
  const items = s.items || [];

  return (
    <section id="detalles" className="relative mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-32">
      <Reveal className="mb-16 max-w-2xl">
        <span className="font-mono-jb text-xs uppercase tracking-[0.35em] text-[color:var(--aurex-accent-soft)]">
          {s.overline || "Detalles"}
        </span>
        <h2 className="mt-5 font-display text-4xl font-extrabold tracking-tight text-[color:var(--aurex-text)] sm:text-5xl">
          {s.title}
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
        {items.map((item, i) => (
          <Reveal
            key={i}
            delay={i * 0.1}
            className={i % 2 === 0 ? "md:col-span-7" : "md:col-span-5"}
          >
            <div className="spotlight group relative h-full overflow-hidden rounded-[1.5rem] border border-white/10 bg-[color:var(--aurex-surface)]">
              <div className="relative overflow-hidden">
                <img
                  src={resolveMedia(item.image)}
                  alt={item.title}
                  className="h-[300px] w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105 md:h-[380px]"
                />
                <div className="absolute inset-0 overlay-surface-top" />
              </div>
              <div className="relative z-10 p-7 md:p-9">
                <h3 className="font-display text-2xl font-bold text-[color:var(--aurex-text)] md:text-3xl">
                  {item.title}
                </h3>
                <p className="mt-3 text-[color:var(--aurex-muted)]">{item.text}</p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {(item.features || []).map((f, k) => (
                    <li
                      key={k}
                      className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 text-xs text-zinc-300"
                    >
                      <Check size={12} className="text-[color:var(--aurex-accent)]" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
